import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="w-full text-white bg-[#002F1D]">
      <div className="max-w-[1240px] mx-auto py-12 px-6 grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Who We Are */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold">Who We Are</h3>
          <p className="text-gray-300 text-[16px] leading-relaxed">
            We are a tours and travel company based in Kampala, Uganda, that will
            give your safari experience to the detail — making you a modern-time
            explorer. With a vast hospitality and business consultancy background,
            we make your African safari experience truly memorable.
          </p>
        </div>

        {/* Quick Links */}
        <div className="cursor-pointer">
          <h3 className="text-[#F59C10] text-xl font-semibold">Quick Links</h3>
          <ul className="text-gray-300 text-[16px] leading-relaxed">
            <li className="py-1 hover:text-[#F59C10]">
              <Link to="/">Home</Link>
            </li>
            <li className="py-1 hover:text-[#F59C10]">
              <Link to="/destinations">Destination</Link>
            </li>
            <li className="py-1 hover:text-[#F59C10]">
              <Link to="/tours">Tours</Link>
            </li>
            <li className="py-1 hover:text-[#F59C10]">
              <Link to="/gallery">Gallery</Link>
            </li>
            <li className="py-1 hover:text-[#F59C10]">
              <Link to="/blogs">Blogs</Link>
            </li>
            <li className="py-1 hover:text-[#F59C10]">
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        {/* Destination */}
        <div className="cursor-pointer">
          <h3 className="text-[#F59C10] text-xl font-semibold">Destinations</h3>
          <ul className="text-gray-300 text-sm leading-relaxed">
            <li className="py-1 hover:text-[#F59C10]">Uganda</li>
            <li className="py-1 hover:text-[#F59C10]">Kenya</li>
            <li className="py-1 hover:text-[#F59C10]">Tanzania</li>
            <li className="py-1 hover:text-[#F59C10]">Rwanda</li>
            <li className="py-1 hover:text-[#F59C10]">South Africa</li>
            <li className="py-1 hover:text-[#F59C10]">Others</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-[#F59C10]">Contact Info</h3>
          <div>
            <h4 className="font-medium">Location</h4>
            <p className="text-gray-300 text-[16px] leading-relaxed">
              3rd Floor Metropole House, Entebbe Road, Kampala, Uganda
            </p>
          </div>
          <p className="text-gray-300 text-[16px] leading-relaxed">
            <span className="text-[#F59C10]">Email:</span>{" "}
            info@gorillandtravelcare.com
          </p>
          <p className="text-gray-300 text-[16px] leading-relaxed">
            <span className="text-[#F59C10]">Tel No:</span> +256 772 642101
          </p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-gray-700"></div>
      <p className="text-gray-400 text-center text-[14px] p-4">
        © {new Date().getFullYear()} Gorilland Travel Care. All rights reserved.
      </p>
    </div>
  );
};

export default Footer;
